module.exports = __webpack_public_path__ + "img/Mstorybg902.f29864d1.png";